import { NgModule } from '@angular/core';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
@NgModule({
  declarations: [],
  imports: [
    NzImageModule,
    NzLayoutModule,
    NzSelectModule,
    NzSpaceModule,
    NzCardModule,
    NzSpinModule,
    NzTableModule,
    NzDropDownModule,
    NzDescriptionsModule,
    NzDrawerModule,
    NzBadgeModule,
    NzIconModule,
    NzButtonModule,
    NzPageHeaderModule,
    NzAvatarModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzFormModule,
    NzInputModule,
    NzStatisticModule,
    NzDatePickerModule,
    NzMessageModule,
    NzTagModule,
    NzDividerModule,
    NzCollapseModule,
    NzModalModule,
    NzResultModule,
    NzSliderModule,
    NzInputNumberModule,
    NzListModule,
    NzCheckboxModule,
    NzRadioModule,
    NzStepsModule,
    NzTransferModule,
    NzSwitchModule,
    NzNotificationModule,
    NzEmptyModule,
    NzAffixModule,
    NzGridModule,
    NzSkeletonModule,
    NzTreeSelectModule,
    NzTimelineModule,
    NzAlertModule
  ],
  exports:[
    NzLayoutModule,
    NzSelectModule,
    NzSpaceModule,
    NzCardModule,
    NzSpinModule,
    NzTableModule,
    NzDropDownModule,
    NzDescriptionsModule,
    NzDrawerModule,
    NzBadgeModule,
    NzIconModule,
    NzButtonModule,
    NzPageHeaderModule,
    NzAvatarModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzFormModule,
    NzInputModule,
    NzStatisticModule,
    NzDatePickerModule,
    NzMessageModule,
    NzTagModule,
    NzDividerModule,
    NzCollapseModule,
    NzModalModule,
    NzResultModule,
    NzSliderModule,
    NzInputNumberModule,
    NzListModule,
    NzCheckboxModule,
    NzRadioModule,
    NzStepsModule,
    NzTransferModule,
    NzSwitchModule,
    NzNotificationModule,
    NzEmptyModule,
    NzAffixModule,
    NzGridModule,
    NzSkeletonModule,
    NzTreeSelectModule,
    NzTimelineModule,
    NzImageModule,
    NzAlertModule
  ]
})
export class NzModule { }
